import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import Slick from 'react-slick'
import { trackPromotionClick } from 'helpers'

export class ImageTextSlider extends React.PureComponent<ImageTextSlider.Props, ImageTextSlider.State> {
  public static sectionId = 'imagewi';
  private sliderRef;
  public constructor(props) {

    super(props)
    this.state = {
      isDesktop: true,
      hovered: false
    }
    this.sliderRef = React.createRef()
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
    
    if (typeof window !== 'undefined') {
      this.setState({
        isDesktop: window.innerWidth > 960
      })
      window.addEventListener('resize', () => {
        this.setState({
          isDesktop: window.innerWidth > 960
        })
      })
    }
  }

  next() {
    this.sliderRef.slickNext()
  }
  previous() {
    this.sliderRef.slickPrev()
  }

    
  public render(): JSX.Element {
    const { section } = this.props
    const { settings, blocks } = section
    const { isDesktop } = this.state
    if (!settings) {
      return <React.Fragment />
    }

    const { title } = settings
    const sliderit = blocks.map(block => {
      return block.settings
    })
    console.log()
    const sliderSettings = {
      centerPadding: '20px',
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      centerMode: false,
      responsive: [
        { 
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            centerPadding: '12px',
            infinite: false,
            centerMode: true,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            centerPadding: '24px',
            infinite: true,

          }
        },
        // {
        //   breakpoint: 1440,
        //   settings: {
        //     slidesToShow: 3,
        //     centerPadding: '0px',
        //   }
        // },
      ]
    }


   

    return (
      <section className={'dynamic-image-with-text-slider pb-4 pt-2'}>
        <Snippets.Heading tag='p' className='py-2-4 font-bold text-center'>
          {title}
        </Snippets.Heading>
        <div className='flex items-center justify-between md:justify-center'>
          <button className="button px-1-2" onClick={this.previous}>
            <Snippets.Icon name={'arrow_left'} width={18} label={'next slide'}/>    
          </button>
          <button className="button px-1-2" onClick={this.next}>
            <Snippets.Icon name={'arrow_right'} width={18} label={'previous slide'}/>    
          </button>
        </div>
        <div className={`${isDesktop ? 'my-2 py-3' : 'mt-2 pt-3'}`}>
          <Slick {...sliderSettings} ref={c => (this.sliderRef = c)}>
            {sliderit.map((item, index) => (
              <div key={index} className='item-container pl-1'>
                <div className='border-b pb-2-4 border-black'>
                  <Snippets.Image
                    alt={settings.title || 'featured image content'}
                    ratio={'5:6'}
                    className={''}
                    src={item.image}
                  />
                </div>
                    
                <Snippets.Heading tag='h1' className='py-2-4'>
                  {item.heading}
                </Snippets.Heading>
                    
                <Snippets.Heading tag='p'>
                  {item.description}
                </Snippets.Heading>
              </div>
            ))}
          </Slick>
          <div className="hidden md:block">
            {!this.state.isDesktop && <Snippets.Heading tag='p' className='pt-4 pb-2-4 font-bold text-center'>
              {title}
            </Snippets.Heading>}
            <div className='flex items-center justify-between pt-4 md:justify-center'>
              <button className="button px-1-2" onClick={this.previous}>
                <Snippets.Icon name={'arrow_left'} width={18} label={'next slide'}/>    
              </button>
              <button className="button px-1-2" onClick={this.next}>
                <Snippets.Icon name={'arrow_right'} width={18} label={'previous slide'}/>    
              </button>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export namespace ImageTextSlider {
  export type Options = ShopifyNext.Section<{
    title: any;
    sliderit: any;
   
  }>;
  export interface Props extends GlobalProps {
    section: ImageTextSlider.Options;
  }
  export interface State { 
    hovered: boolean;
    isDesktop: boolean;
  }
}
